import { ListChecks } from 'lucide-react'

import { areaTypeOptions, areaStatusOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useAreaFilters } from './hooks/useAreaFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    clearAllFilters,
    hasActiveFilters,
    updateAreaType,
    updateAreaStatus,
  } = useAreaFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            onSearchChange={updateSearch}
            placeholder="Buscar por nombre de área..."
            searchQuery={filters.search}
          />

          <SelectFilter
            activeSelections={filters.type}
            icon={<ListChecks className="h-4 w-4" />}
            onSelectionsChange={updateAreaType}
            placeholder="Buscar tipo..."
            searchActive={false}
            selectionOptions={areaTypeOptions}
            title="Tipo"
          />

          <SelectFilter
            activeSelections={filters.isActive}
            icon={<ListChecks className="h-4 w-4" />}
            onSelectionsChange={updateAreaStatus}
            placeholder="Buscar estado..."
            searchActive={false}
            selectionOptions={areaStatusOptions}
            title="Estado"
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            activeStatuses={filters.isActive}
            activeTypes={filters.type}
            handleClearFilters={handleClearFilters}
            searchQuery={filters.search}
            setActiveStatuses={updateAreaStatus}
            setActiveTypes={updateAreaType}
            setSearchQuery={updateSearch}
            statusOptions={areaStatusOptions}
            typeOptions={areaTypeOptions}
          />
        )}
      </div>
    </div>
  )
}
